import {
    GET_ORGANIZATION_FAILURE,
    GET_ORGANIZATION_REQUEST,
    GET_ORGANIZATION_SUCCESS
} from "../actions/actionTypes";

const initialState = {
    id: null,
    name: null,
    isFetching: false,
};

const organizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORGANIZATION_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            });
        case GET_ORGANIZATION_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                id: action.response.id,
                name: action.response.name,
            });
        case GET_ORGANIZATION_FAILURE:
            return initialState;
        default:
            return state;
    }
};

export default organizationReducer;
